import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { Router } from "@main/Router";

import "./scss/custom.scss";
import { GetInPaymentConfirmationActionProvider } from "@beeldit/ecommerce/super-orders/actions/getInPaymentConfirmation/GetInPaymentConfirmationActionContext";
import { PendingDealersActionProvider } from "@beeldit/user-and-access/users/actions/pending-dealers/PendingDealersActionContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <GetInPaymentConfirmationActionProvider>
      <PendingDealersActionProvider>
        <Router />
      </PendingDealersActionProvider>
    </GetInPaymentConfirmationActionProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
